import React, { useContext } from "react";
import { LinkContext } from "../../../context";
import { Heading, LinkButton } from "../../atoms";
import { ArrowRight } from "../../icons";
export var ServiceGridCard = function(param) {
    var title = param.title, callToAction = param.callToAction, className = param.className;
    var LinkComponent = useContext(LinkContext).LinkComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, /*#__PURE__*/ React.createElement(LinkComponent, {
        draggable: false,
        className: "flex",
        href: callToAction.href,
        download: callToAction.download,
        target: callToAction.target
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-between"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-5 md:gap-6"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3",
        className: "text-5xl"
    }, title)), /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement(LinkButton, {
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
        className: "mt-9"
    }, callToAction.label)))));
};

//# sourceMappingURL=ServiceGridCard.js.map